<template>
    <div class="flex flex-col md:flex-row items-start md:justify-end gap-5 md:gap-8 lg:gap-22">
        <div class="flex flex-col">
            <FoundationHeadline tag="h3" class="h3 font-bold uppercase">{{ $t('layout.footerTopBar.subscribeOurNewsletter') }}</FoundationHeadline>
            <div class="text-sm">{{ $t('layout.footerTopBar.ensureRegularBenefits') }}</div>
        </div>
        <NuxtLink :to="'/Newsletter'" class="btn btn-primary mb-1">
            {{ $t('layout.footerTopBar.subscribeNow') }}
        </NuxtLink>
    </div>
</template>